import { i18n } from "@lingui/core";
import { TradeOrgPages } from "./types/tradeorgPages.ts";

export const getTitle = (pageName?: TradeOrgPages) => {
  switch (pageName) {
    case TradeOrgPages.NBF:
      return i18n.t({
        id: "tradeOrgLayout.nbf.page.title",
        message: "Norwegian Automobile Industry Association (NBF)",
        comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
      });
    case TradeOrgPages.Norboat:
      return i18n.t({
        id: "tradeOrgLayout.norboat.page.title",
        message: "Norboat, The Boating Industry Association in Norway",
        comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
      });
    case TradeOrgPages.NCB:
      return i18n.t({
        id: "tradeOrgLayout.ncb.page.title",
        message: "Norwegian Caravan Industry Association (NCB) ",
        comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
      });
    case TradeOrgPages.NMCF:
      return i18n.t({
        id: "tradeOrgLayout.nmcf.page.title",
        message: "Norwegian MC Dealers Association (NMCF)",
        comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
      });
    case TradeOrgPages.MobilityPool:
      return "Mobility Pool AS";
    case TradeOrgPages.Bruktbilgruppen:
      return i18n.t({
        id: "tradeOrgLayout.bruktbilgruppen.page.title",
        message: "Bruktbilgruppen AS",
        comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
      });
    case TradeOrgPages.Smabatregisteret:
      return i18n.t({
        id: "tradeOrgLayout.smabatregisteret.page.title",
        message: "Småbåtregisteret",
        comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
      });
    case TradeOrgPages.MRF:
      return "Motorbranschens Riksförbund (MRF)";
    case TradeOrgPages.Sweboat:
      return "Sweboat";
    case TradeOrgPages.MGF:
      return "Maskingrossisternes Forening (MGF)";
    default:
      return i18n.t({
        id: "tradeOrgLayout.default.page.title",
        message: "Trade organization benefits",
        comment: "Default Page Title - if there's non created for current trade organization",
      });
  }
};
